import { render, staticRenderFns } from "./Archief.vue?vue&type=template&id=456b5ffe&"
import script from "./Archief.vue?vue&type=script&lang=js&"
export * from "./Archief.vue?vue&type=script&lang=js&"
import style0 from "./Archief.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports